import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["value", "hidden", "disabled"];
import { ___ } from '@ts/common/language';
import {} from '@ts/components/form/types';
import { computed, ref, watch } from 'vue';
import { useId } from 'vue';
import { setError, removeError } from '@ts/components/form/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PureSelect',
    props: /*@__PURE__*/ _mergeModels({
        options: {},
        emptyOption: {},
        errorId: { default: () => useId() }
    }, {
        "value": { required: true },
        "valueModifiers": {},
        "errors": { required: false, default: () => ({}) },
        "errorsModifiers": {},
    }),
    emits: ["update:value", "update:errors"],
    setup(__props) {
        const props = __props;
        const value = _useModel(__props, 'value');
        const errors = _useModel(__props, 'errors');
        const selected = ref('');
        const computedOptions = computed(() => {
            const emptyOpt = props.emptyOption !== undefined
                ? (typeof props.emptyOption === 'string' || props.emptyOption instanceof String)
                    ? { label: props.emptyOption, disabled: true, hidden: true }
                    : { ...props.emptyOption }
                : { label: ___({ en: 'Select an option', de: 'Wähle eine Option' }), disabled: true, hidden: true };
            const opts = {
                '': emptyOpt,
            };
            for (const key in props.options) {
                const opt = props.options[key];
                opts[key] = typeof opt === 'string' || opt instanceof String
                    ? { label: opt }
                    : { ...opt };
            }
            return opts;
        });
        watch(() => value.value, () => {
            // console.log('Value changed:', value.value);
            if (value.value === selected.value) {
                return;
            }
            const optModel = computedOptions.value[value.value] ?? undefined;
            if (optModel === undefined) {
                setError(errors, props.errorId, 'invalid-value', ___({ en: 'Value does not match any option', de: 'Wert entspricht keiner Option' }));
            }
            else {
                removeError(errors, props.errorId, 'invalid-value');
            }
            if (optModel !== undefined) {
                selected.value = value.value;
            }
            else {
                selected.value = '';
            }
        }, { immediate: true });
        watch(() => selected.value, () => {
            // console.log('Selected changed:', JSON.stringify(selected.value));
            if (value.value === selected.value) {
                return;
            }
            const optModel = computedOptions.value[value.value] ?? undefined;
            const optSelected = computedOptions.value[selected.value] ?? undefined;
            if (optSelected === undefined) {
                setError(errors, props.errorId, 'invalid-selected', ___({ en: 'Selected value does not match any option', de: 'Ausgewählter Wert entspricht keiner Option' }));
            }
            else {
                removeError(errors, props.errorId, 'invalid-selected');
            }
            if (selected.value !== '' || (optModel !== undefined && optSelected !== undefined)) {
                value.value = selected.value;
            }
        });
        watch(() => props.options, () => {
            // console.log('Options changed:', props.options);
            const optModel = computedOptions.value[value.value] ?? undefined;
            if (optModel === undefined) {
                setError(errors, props.errorId, 'invalid-value', ___({ en: 'Value does not match any option', de: 'Wert entspricht keiner Option' }));
                selected.value = '';
            }
            else {
                removeError(errors, props.errorId, 'invalid-value');
                selected.value = value.value;
            }
        }, { deep: true });
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selected).value = $event)),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["enter"]))
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(computedOptions.value), (value, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: value,
                        hidden: computedOptions.value[value].hidden === true,
                        disabled: computedOptions.value[value].disabled === true
                    }, _toDisplayString(typeof computedOptions.value[value].label === 'string' ? computedOptions.value[value].label : _unref(___)(computedOptions.value[value].label)), 9 /* TEXT, PROPS */, _hoisted_1));
                }), 128 /* KEYED_FRAGMENT */))
            ], 544 /* NEED_HYDRATION, NEED_PATCH */)), [
                [_vModelSelect, selected.value]
            ]);
        };
    }
});
